import React from 'react';
import { useDynamicStatus } from '@/hooks/useDynamicStatus';

interface DynamicStatusIndicatorProps {
  isActive: boolean;
  hasFile?: boolean;
}

const DynamicStatusIndicator: React.FC<DynamicStatusIndicatorProps> = ({ 
  isActive, 
  hasFile = false 
}) => {
  const { currentStatus } = useDynamicStatus({ 
    isActive, 
    hasFile,
    interval: 500 // ⚡ INTERVALO ULTRA-RÁPIDO para animação fluida
  });

  if (!isActive) return null;

  return (
    <div className="flex justify-start w-full max-w-4xl mx-auto px-2 md:px-4 animate-fade-up">
      <div className="rounded-xl px-3 py-2 md:px-4 md:py-3 bg-secondary text-secondary-foreground rounded-tl-none max-w-[95%] sm:max-w-[90%] md:max-w-[85%]">
        <div className="flex items-center gap-2">
          <div className="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
          {/* ⚡ NOVA ANIMAÇÃO: "Pensando..." com opacidade pulsante 30%-100% */}
          <span className="text-sm text-secondary-foreground transition-opacity duration-300" style={{
            animation: 'pulse 1.5s ease-in-out infinite'
          }}>
            {currentStatus}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DynamicStatusIndicator;